import { useFlag } from "@mindlercare/unleash-client";
import CONSTANTS from "core/constants";
import { useTranslation } from "react-i18next";
import { Typography } from "components/typography";
import { Spacing, RadioGroup } from "@mindlercare/ui-web";

type EmploymentTypeProps = {
  value: string | null | undefined;
  setEmploymentType: (employmentType: string) => void;
  psychologistValidation: string[];
};

export const EmploymentTypeSection = ({
  value,
  setEmploymentType,
  psychologistValidation,
}: EmploymentTypeProps) => {
  const { t } = useTranslation();
  const hasError = psychologistValidation.includes("employmentType");
  const hide = useFlag("HIDE_MC_PSYCHOLOGIST_STATUSES");

  if (hide) return null;

  return (
    <div>
      <Typography
        variant="body-x-small"
        color={hasError ? "ERROR" : "GRAY_DARK"}
        insensitive
      >
        {`${t("PSYCHOLOGIST_STATUSES.EMPLOYMENT")} (${t("PSYCHOLOGIST_STATUSES.ONLY_VISIBLE_BY_CS_AND_ADMIN")})`}
      </Typography>

      <Spacing t={12} />

      <RadioGroup
        defaultValue={value ?? undefined}
        aria-labelledby="psychologist-employment-type-label"
        onChange={(currentValue) => {
          setEmploymentType(currentValue);
        }}
      >
        <RadioGroup.RadioButton
          name={CONSTANTS.PSYCHOLOGIST.EMPLOYMENT_TYPE.PART_TIME}
        >
          <span>{t("PSYCHOLOGIST_STATUSES.EMPLOYMENT_PART_TIME")}</span>
        </RadioGroup.RadioButton>
        <RadioGroup.RadioButton
          name={CONSTANTS.PSYCHOLOGIST.EMPLOYMENT_TYPE.FULL_TIME}
        >
          <span>{t("PSYCHOLOGIST_STATUSES.EMPLOYMENT_FULL_TIME")}</span>
        </RadioGroup.RadioButton>
      </RadioGroup>
    </div>
  );
};
